<template>
  <div>
    <!-- <div id='player-1'></div> -->
    <youtube
      :video-id="videoId"
      ref="youtube"
      @playing="playing"
      :player-vars="playerVars"
      @ended="ended"
    ></youtube>
  </div>
</template>

<script>
import YouTubePlayer from "youtube-player";
export default {
  name: "test",
  data() {
    return {
      play1: "",
      firstStateChange: "",
      videoId: "9L3P67caW8c",
      playerVars: {},
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    },
  },
  methods: {
    playing() {
      console.log("o/ we are watching!!!");
    },
    youtubStateChange(youtubeState) {
      //監聽任何操作
      console.log("youtubeState:", youtubeState.target.getIframe().id);
    },
    ended() {
      //結束之後會執行這個function
      console.log("END");
    },
  },
  mounted() {
    // console.clear()
    console.log(window.location.protocol, window.location.href);
    this.player.addEventListener("onStateChange", this.youtubStateChange);
  },
};
</script>

<style>
</style>